import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {NgxMasonryModule} from 'ngx-masonry';

import {CubesManagerComponent, CubeTemplateDirective} from './cubes-manager';
import {CubeComponent, CubeFaceDirective} from './cube';

import {register} from 'swiper/element/bundle';
register();

@NgModule({
  declarations: [
    CubesManagerComponent,
    CubeFaceDirective,
    CubeTemplateDirective,
    CubeComponent,
  ],
  imports: [
    CommonModule,
    NgxMasonryModule,
  ],
  exports: [
    CubesManagerComponent,
    CubeFaceDirective,
    CubeTemplateDirective,
    CubeComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CubesManagerModule {
}
